import React, { useRef } from 'react';
import { clients } from '../core/data/clients';
import ClientCard from './ClientCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleArrowLeft, faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';

const ClientsManual = () => {
  // Duplicate the clients array to have it loopable
  const carouselClients = [...clients];
  // Use a ref to directly access the scrollable div
  const carouselRef = useRef(null);

  // Function to scroll left
  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: -carouselRef.current.offsetWidth, // Scroll by the container's width
        behavior: 'smooth',
      });
    }
  };

  // Function to scroll right
  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({
        left: carouselRef.current.offsetWidth, // Scroll by the container's width
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className='flex flex-col text-text dark:text-darktext text-4xl text-center'>
      <div className='w-full text-3xl sm:text-4xl md:text-5xl'>
        <p className='text-balance font-bold mb-4'>Somos los Creadores Originales del Sistema de Líneas</p>
       {/*
        <p>Nuestros Clientes</p>
        
        <div className="mt-2 text-lg text-text dark:text-darktext ">
        Visible on mobile devices 
        <p className="block sm:hidden">
          Desliza para explorar todos nuestros clientes.
        </p>
      </div>
        */}
      </div>

      {/* Carousel 
      <div className='relative my-5 mr-5 ml-5 flex flex-row justify-center'>
        Left Arrow 
        <button
          className='mr-2 hidden sm:block' // Hide on mobile, show on small and larger screens
          onClick={scrollLeft}
        >
          <FontAwesomeIcon
            icon={faCircleArrowLeft}
            className="text-4xl cursor-pointer"
          />
        </button>

        Carousel Container 
        <div className='overflow-x-scroll scrollbar-hide w-full sm:w-3/4' ref={carouselRef}>
          <div className='flex whitespace-nowrap space-x-2 '>
            {carouselClients.map((client, index) => (
              <ClientCard client={client} key={index} />
            ))}
          </div>
        </div>

        Right Arrow 
        <button
          className='ml-2 hidden sm:block' // Hide on mobile, show on small and larger screens
          onClick={scrollRight}
        >
          <FontAwesomeIcon
            icon={faCircleArrowRight}
            className="text-4xl cursor-pointer"
          />
        </button>
      </div>
      */}
    </div>
  );
};

export default ClientsManual;
